import React from 'react';

import { type TTabButton } from '../enums/TabButtonType';
import { ETabButton } from '../enums/TabButtonType';
import XDButton from './buttons/XDButton';

interface Props {
  isSelected: boolean | undefined;
  label: string | undefined;
  text?: string | JSX.Element;
  labelKey?: string;
  onClick: (selectedTab: string | undefined) => void;
  buttonType?: TTabButton;
}

export default function CTabButton(props: Props) {
  const buttonType = props.buttonType ?? ETabButton.DEFAULT;

  const isLink = buttonType === ETabButton.LINK;
  const baseStylesSelected = isLink ? 'bg-teal-3 uppercase' : 'bg-teal normal-case';
  const baseStylesUnselected = isLink ? 'uppercase' : 'normal-case';

  switch (props.isSelected) {
    case true:
      return (
        <XDButton
          className={`${baseStylesSelected} text-white font-bold px-5 hover:bg-opacity-80 hover:text-white whitespace-nowrap`}
          style={{
            borderRadius: '8rem'
          }}
          onClick={() => {
            props.onClick(props.labelKey ?? props.label);
          }}
        >
          {props.text}
        </XDButton>
      );
    default:
      return (
        <XDButton
          className={`${baseStylesUnselected} bg-gray-100 text-gray-500 font-bold px-5 whitespace-nowrap`}
          style={{
            borderRadius: '8rem'
          }}
          onClick={() => {
            props.onClick(props.labelKey ?? props.label);
          }}
        >
          {props.text}
        </XDButton>
      );
  }
}
